import { useConnectionStore } from '../../../../connections/store/connectionStore';
import { openStorageExplorerTab } from '../../utils/openStorageExplorerTab';
import { STORAGE_READ_ONLY_REASON } from '../../../../../core/engines/azureStorageRefusal';
import { CreateStorageTableDialog } from './CreateStorageTableDialog';
import { DeleteStorageTableDialog } from './DeleteStorageTableDialog';
import { useStorageTableDialogStore } from './storageTableDialogStore';

export function StorageTableDialogsHost() {
  const createRequest = useStorageTableDialogStore((state) => state.createRequest);
  const deleteRequest = useStorageTableDialogStore((state) => state.deleteRequest);
  const closeCreate = useStorageTableDialogStore((state) => state.closeCreate);
  const closeDelete = useStorageTableDialogStore((state) => state.closeDelete);
  const connections = useConnectionStore((state) => state.connections);
  const createConnection = connections.find((connection) => connection.id === createRequest?.connectionId);
  const deleteConnection = connections.find((connection) => connection.id === deleteRequest?.connectionId);

  return (
    <>
      {createRequest && <CreateStorageTableDialog
        open
        connectionId={createRequest.connectionId}
        onOpenChange={(open) => { if (!open) closeCreate(); }}
        disabledReason={!createConnection ? 'Connection is unavailable.' : createConnection.readOnly ? STORAGE_READ_ONLY_REASON : createConnection.azureStorageScope?.kind === 'resource' ? 'This attachment cannot create sibling tables.' : undefined}
        onCreated={(table) => openStorageExplorerTab({ connectionId: createRequest.connectionId, root: { kind: 'table', table }, source: 'tree' })}
      />}
      {deleteRequest && <DeleteStorageTableDialog
        open
        connectionId={deleteRequest.connectionId}
        table={deleteRequest.table}
        onOpenChange={(open) => { if (!open) closeDelete(); }}
        readOnlyReason={!deleteConnection ? 'Connection is unavailable.' : deleteConnection.readOnly ? STORAGE_READ_ONLY_REASON : undefined}
        onDeleted={closeDelete}
      />}
    </>
  );
}
